import useTrackingComponents from 'src/hooks/requests/useTrackingComponentOptions'

import SelectDropdown from '../MUI/SelectDropdown'

interface TrackedByComponentsSelectorProp {
  aircraftId: string
  name?: string
  disabled?: boolean
  includeAll?: boolean
}

const TrackedByComponentsSelector: React.FC<
  TrackedByComponentsSelectorProp
> = ({ aircraftId, name, disabled, includeAll = false }) => {
  const { trackingComponentOptions, loading, hasLoaded } =
    useTrackingComponents(aircraftId)
  const renderValue = (selectedValue: any) => {
    if (typeof selectedValue === 'object' && selectedValue !== null) {
      return selectedValue.name // Assuming the object has a 'name' property
    }
    return selectedValue
  }
  return (
    <SelectDropdown
      name={name || 'trackedBy'}
      label="Tracked By"
      options={includeAll ? [{ label: 'All', value: {id: 'All', name: 'All'} }, ...trackingComponentOptions] : trackingComponentOptions}
      loading={loading}
      disabled={disabled || !hasLoaded}
      fullWidth
      renderValue={renderValue}
    />
  )
}

export default TrackedByComponentsSelector
